/** @jsxImportSource @emotion/react */
import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Card } from "primereact/card";
import { Column } from "primereact/column";
import { Toast } from "primereact/toast";
import { Skeleton } from "primereact/skeleton";
import { Tag } from "primereact/tag";
import {
  Boton,
  Titulo,
  Formulario,
  accessAPI,
  Sidebar,
  tituloBase,
  TablaFiltrable
} from "../../../../shared";

const SEARCH_FIELDS = ["nombre"];

export default function EstadosCertificados() {
  const [loader, setLoader] = useState(true);
  const [estados, setEstados] = useState([]);
  const [sideBar, setSideBar] = useState(false);
  const [formLoader, setFormLoader] = useState(false);

  const toast = useRef(null);
  const navigate = useNavigate();

  function crearEstado(camposFormulario) {
    setFormLoader(true);
    accessAPI(
      "POST",
      "admin/config/estadocertificado",
      camposFormulario,
      (respuesta) => {
        navigate(`/estadocertificado/${respuesta.id}`);
      },
      (respuesta) => {
        setFormLoader(false);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al crear estado de certificado",
          sticky: true
        });
      }
    );
  }

  const crearFormConfig = {
    secciones: [
      {
        nombre: "Datos del estado",
        campos: [
          {
            nombre: "nombre",
            tipoitemformularioid: 1,
            etiqueta: "Nombre",
            requerido: true
          },
          {
            nombre: "vigentebool",
            tipoitemformularioid: 6,
            etiqueta: "Es un estado vigente"
          },
          {
            nombre: "bajadefinitiva",
            tipoitemformularioid: 6,
            etiqueta: "Es un estado de baja definitiva"
          }
        ]
      }
    ],
    botones: [
      { etiqueta: "Crear estado", callback: crearEstado, validar: true }
    ]
  };

  useEffect(() => {
    document.title = "Estados de certificados";
    accessAPI(
      "GET",
      "admin/config/estadocertificado",
      null,
      (respuesta) => {
        setEstados(respuesta);
        setLoader(false);
      },
      (respuesta) => {
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail:
            respuesta[0]?.msg || "Error al cargar estados de certificados",
          sticky: true
        });
        setLoader(false);
      }
    );
    return () => (document.title = tituloBase());
  }, []);

  return (
    <>
      <Toast ref={toast} position="top-center" />

      <Sidebar
        visible={sideBar}
        onHide={() => setSideBar(false)}
        position="right"
        className="w-full lg:w-30rem md:w-30rem"
      >
        <Titulo>Nuevo estado de certificado</Titulo>
        <Formulario config={crearFormConfig} loader={formLoader} />
      </Sidebar>

      {loader && (
        <div
          css={{
            marginTop: "2em",
            display: "flex",
            flexDirection: "column",
            gap: "0.5rem"
          }}
        >
          <div
            css={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: "0.5rem"
            }}
          >
            <Skeleton width="15rem" height="2.5rem" />
            <Skeleton width="16rem" height="2.5rem" />
          </div>
          <Card>
            <div
              css={{
                display: "flex",
                flexDirection: "column",
                gap: "0.5rem"
              }}
            >
              <Skeleton width="100%" height="3rem" />
              {[...Array(5)].map((_, i) => (
                <Skeleton key={i} width="100%" height="3.5rem" />
              ))}
            </div>
          </Card>
        </div>
      )}

      {!loader && (
        <div>
          <Titulo
            urlVolver="/config"
            botones={
              <Boton callback={() => setSideBar(true)}>
                Nuevo estado de certificado
              </Boton>
            }
          >
            Estados de certificados
          </Titulo>

          <Card>
            <TablaFiltrable
              value={estados}
              searchFields={SEARCH_FIELDS}
              anchoBusqueda="33%"
              nombreArchivo="estados_certificados"
              emptyMessage="No hay estados de certificados registrados"
              onRowClick={(e) => {
                if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
                  window.open(
                    `/estadocertificado/${e.data.id}`,
                    "_blank"
                  );
                } else {
                  navigate(`/estadocertificado/${e.data.id}`);
                }
              }}
              rows={10}
              css={{
                "& .p-datatable-tbody > tr": { cursor: "pointer" }
              }}
            >
              <Column header="Nombre" field="nombre" />
              <Column
                header="Vigente"
                body={(rowData) => (
                  <Tag
                    severity={rowData.vigentebool ? "success" : "danger"}
                    css={{ fontSize: "0.75rem" }}
                  >
                    <i
                      className={
                        rowData.vigentebool ? "pi pi-check" : "pi pi-times"
                      }
                    />
                  </Tag>
                )}
                style={{ width: "6rem", textAlign: "center" }}
              />
              <Column
                header="Baja definitiva"
                body={(rowData) => (
                  <Tag
                    severity={rowData.bajadefinitiva ? "success" : "danger"}
                    css={{ fontSize: "0.75rem" }}
                  >
                    <i
                      className={
                        rowData.bajadefinitiva ? "pi pi-check" : "pi pi-times"
                      }
                    />
                  </Tag>
                )}
                style={{ width: "10rem", textAlign: "center" }}
              />
            </TablaFiltrable>
          </Card>
        </div>
      )}
    </>
  );
}
